<template lang="pug">
.row.bs-wizard(
    :class="{ 'completed': status == 4 }"
)
    .bs-wizard-step.complete(
        :style="{ width: '20%', 'display': 'inline-block' }",
    )
        .text-center.bs-wizard-stepnum
            | &nbsp; 
            span.hidden-xs-down Create
        .progress
            .progress-bar
        a.bs-wizard-dot
        .bs-wizard-info.text-center

    .bs-wizard-step(
        :style="{ width: '20%', 'display': 'inline-block' }",
        :class="{ 'complete': status >= 0 && status !== null, 'disabled': status == null }"
    )
        .text-center.bs-wizard-stepnum
            | &nbsp; 
            span.hidden-xs-down Editing
        .progress
            .progress-bar
        a.bs-wizard-dot
        .bs-wizard-info.text-center

    .bs-wizard-step(
        :style="{ width: '20%', 'display': 'inline-block' }",
        :class="{ 'complete': status >= 2, 'disabled': status == null || status < 2 }"
    )
        .text-center.bs-wizard-stepnum
            | &nbsp; 
            span.hidden-xs-down Waiting Approval
        .progress
            .progress-bar
        a.bs-wizard-dot
        .bs-wizard-info.text-center

    .bs-wizard-step(
        :style="{ width: '20%', 'display': 'inline-block' }",
        :class="{ 'complete': status >= 3, 'disabled': status == null || status < 3 }"
    )
        .text-center.bs-wizard-stepnum
            | &nbsp; 
            span.hidden-xs-down Approved & Shipped
        .progress
            .progress-bar
        a.bs-wizard-dot
        .bs-wizard-info.text-center

    .bs-wizard-step(
        :style="{ width: '20%', 'display': 'inline-block' }",
        :class="{ 'complete': status == 4, 'disabled': status == null || status < 4 }"
    )
        .text-center.bs-wizard-stepnum
            | &nbsp; 
            span.hidden-xs-down Received
        .progress
            .progress-bar
        a.bs-wizard-dot
        .bs-wizard-info.text-center
</template>

<script>
export default {
    props: {
        status: {
            type: Number,
            default: null,
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/stock_request/stock-request-step.vue